import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";

function CompOffRecordAll() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.adminRole !== "manager"
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reload, setReload] = useState(false);
  const [recordData, setRecordData] = useState([]);

  // fetch records
  async function getRecords() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/manager/all/comp-off/records/${page}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTotalPages(res.data?.data?.totalPages || 0);
      setRecordData(res.data?.data?.data || []);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Records fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getRecords();
  }, [reload, page]);

  if (recordData.length === 0) {
    return (
      <div>
        <p className="text-center text-slate-500 font-medium mt-10">
          No record found
        </p>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Comp OFF Records
          </h1>
          <div className="mt-5">
            <Table>
              <TableHead>
                <TableRow className="!bg-blue-500">
                  <TableCell className="!text-center !text-white">SL No</TableCell>
                  <TableCell className="!text-center !text-white">Employee</TableCell>
                  <TableCell className="!text-center !text-white">Date</TableCell>
                  <TableCell className="!text-center !text-white">Status</TableCell>
                  <TableCell className="!text-center !text-white">Leave Name</TableCell>
                  <TableCell className="!text-center !text-white">Total Working Hours</TableCell>
                  <TableCell className="!text-center !text-white">More</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="border">
                {recordData.map((data, i) => (
                  <TableRow className="">
                    <TableCell className="!text-center">{i + 1}</TableCell>
                    <TableCell className="!text-center">{data?.userData?.fullName}{" "}({data?.userData?.role})</TableCell>
                    <TableCell className="!text-center">{new Date(data?.leaveDate).toLocaleDateString("en-IN")}</TableCell>
                    <TableCell className="!text-center">{data?.isCanceled ? <p className="text-red-500 font-medium">Canceled</p> : "Not Canceled"}</TableCell>
                    <TableCell className="!text-center">{data?.leaveName}</TableCell>
                    <TableCell className="!text-center">{(Number(data?.totalWorikingHours) / 60).toFixed(2)} hours</TableCell>
                    <TableCell className="!text-center">
                      <Link to={`/admin/comp-off/single/record/${data?._id}`}>
                        <ButtonCompo>More</ButtonCompo>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompOffRecordAll;
